import axios from '@/libs/axios'

export const encargoServices = {
  loadTable(params) {
    return axios.get('/financeiro/encargos', { params })
  },
  loadAll() {
    return axios.get('/financeiro/encargos/lista')
  },
  findById(id) {
    return axios.get(`/financeiro/encargos/${id}`)
  },
  insert(data) {
    return axios.post('/financeiro/encargos', data)
  },
  update(id, data) {
    return axios.put(`/financeiro/encargos/${id}`, data)
  },
  delete(id) {
    return axios.delete(`/financeiro/encargos/${id}`)
  }
}
